{
  "DocumentsPlusWizardListComponent": {
    "TABLE": {
      "SELECT": true,
      "DATE_REC": true,
      "DESCRIPTION": true,
      "TYPE": true,
      "PAGE_COUNT": true,

      "TABLE_ACTIONS": {
        "VIEW": true
      }
    }
  }
}
